import React, { Component } from 'react';

import Image from 'Demora/image';

import resizeImage from 'Demora/resizeImage';

import classnames from 'classnames';

class UploadProfileImage extends Component {
	constructor(props) {
		super();

		this.state = {
			images: props.image ? [props.image] : null,
			singleImage: props.singleImage ? props.singleImage : true,
		};

		this.chooseImage = this.chooseImage.bind(this);

		this.returnImages = this.returnImages.bind(this);
	}

	chooseImage(e) {
		e.preventDefault();

		var file = e.target.files[0];

		resizeImage(file, 800, 800)
			.then((image) => {
				if (image.imgSrc.length > 1024 * 1024) {
					errorModal(
						'The image is too big, try resizing the image so it is less than 1Mb'
					);
					return;
				}

				this.setState((st) => {
					if (this.state.singleImage) {
						st.images = [image];
					} else {
						st.images.push(image);
					}

					return { images: st.images };
				});
			})
			.catch((error) => {
				errorModal('There was an error uploading your image');
			});
	}

	returnImages() {
		this.props.returnImages(this.state.images);
	}

	render() {
		return (
			<div className='row'>
				<div className='col-6'>
					{this.state.images &&
						this.state.images.map((image, k) => {
							if (image.imgSrc) {
								return (
									<img
										key={k}
										src={image.imgSrc}
										className='rounded'
										style={{ maxWidth: '100%' }}
									/>
								);
							} else {
								return (
									<img
										key={k}
										src={Image(image, 0)}
										className='rounded'
										style={{ maxWidth: '100%' }}
									/>
								);
							}
						})}
				</div>

				<div className='col-6 d-flex align-items-center flex-column flex-grow-0'>
					<label
						className={classnames('uploadButton input-group-text')}
						style={{ backgroundColor: '#fff', border: 0 }}
					>
						<input type='file' onChange={this.chooseImage} />
						<span className='btn btn-primary'>Choose Image</span>
					</label>

					<button className='btn btn-danger' onClick={this.returnImages}>
						Save
					</button>
				</div>
			</div>
		);
	}
}

export default UploadProfileImage;
